import { useEffect } from 'react';
import {
  Dialog,
  Typography,
  Box,
  Grid,
  Button,
  Stack,
  IconButton,
} from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

import {
  useGetAuthenticationQuery,
  useUpdateDomainMutation,
} from '../../services/ADapi';

import useValidateDomain from '../../hooks/useValidateDomain';

import TextField from '../text-field/TextField';

const UpdateDomain = ({ domainId, domainName, onClose }) => {
  const {
    data: { user_id },
  } = useGetAuthenticationQuery();

  const [updateDomain] = useUpdateDomainMutation();

  const {
    name,
    nameIsBlur,
    nameError,
    formIsValid,
    formIsSuccess,
    nameHandler,
    blurHandler,
    setName,
    setNameError,
    setFormIsValid,
    setFormIsSuccess,
  } = useValidateDomain();

  useEffect(() => {
    setName(domainName);
  }, [domainName, setName]);

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      await updateDomain({
        user_id,
        id: domainId,
        payload: { name },
      });

      onClose();

      setFormIsSuccess(!formIsSuccess);
      setFormIsValid(false);
    } catch (error) {
      console.error(error);
    }

    setName('');
    setNameError('');
  };

  return (
    <Dialog open={true}>
      <Stack sx={{ gap: 3, width: '460px' }}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Rename</Typography>
          <IconButton onClick={onClose}>
            <CancelOutlinedIcon />
          </IconButton>
        </Grid>
        <Box component="form">
          <TextField
            id="domainName"
            label="Domain name"
            value={name}
            onBlur={blurHandler}
            onChange={nameHandler}
          />
          {nameIsBlur && nameError && (
            <Box className="validate-error" sx={{ top: '69px' }}>
              {nameError}
            </Box>
          )}
          <Grid container sx={{ pt: 3, gap: 3 }}>
            <Button variant="outlined" onClick={onClose} sx={{ flex: '1 0' }}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={submitForm}
              disabled={!formIsValid}
              sx={{ flex: '1 0' }}
            >
              Save
            </Button>
          </Grid>
        </Box>
      </Stack>
    </Dialog>
  );
};

export default UpdateDomain;
